import {UI} from "../../../stem-core/src/ui/UIBase.js";

import {styleRuleInherit} from "stem-core/src/ui/Style.js";
import {styleRule} from "stem-core/src/decorators/Style.js";
import {registerStyle} from "stem-core/src/ui/style/Theme.js";
import {Messages} from "../../Messages.js";
import {getWindowWidth, isSmallScreen} from "../../UtilsLib.js";
import {CDSAccountLookup} from "./CDSAccountLookup.jsx";
import {BasePanelPageStyle} from "../PanelPage.jsx";
import {AuthStartPanel, AuthStartPanelStyle} from "../../website/unauthenticated/slides/AuthStartPanel.jsx";
import {AuthPanelPage} from "./AuthPanelPage.jsx";
import {Router} from "../../../stem-core/src/ui/Router.jsx";
import {LOGIN_WITH_EMAIL_CODE_URL, SMALL_SCREEN_WIDTH_LIMIT} from "../../Constants.js";


class CDSAuthStartPanelStyle extends AuthStartPanelStyle {
    @styleRule
    authContainer = {
        display: "flex",
        flexDirection: () => getWindowWidth() <= SMALL_SCREEN_WIDTH_LIMIT ? "column" : "row",
        marginBottom: -4,
    };

    @styleRule
    authColumn = {
        flex: 1,
        ":first-child": {
            marginRight: () => isSmallScreen() ? 0 : 36,
        },
        ":last-child": {
            marginLeft: () => isSmallScreen() ? 0 : 36,
        },
    };

    @styleRule
    authCDSDescription = {
        textAlign: "center",
        marginBottom: 32,
    };

    @styleRule
    verticalLine = {
        width: 1,
        background: "#E3E3E3",
        marginBottom: 14,
    };

    @styleRule
    footerSection = {
        textAlign: "center",
    }
}


@registerStyle(CDSAuthStartPanelStyle)
class CDSAuthStartPanel extends AuthStartPanel {
    render() {
        const {styleSheet} = this;

        return [
            <div className={styleSheet.authContainer}>
                <div className={styleSheet.authColumn}>
                    {this.getHeaderSection()}
                    {this.getEmailInputSection()}
                </div>
                <div className={styleSheet.verticalLine} />
                <div className={styleSheet.authColumn}>
                    <div className={styleSheet.title}>
                        {Messages.lookUpPrintMagazineTitle}
                    </div>
                    <div className={styleSheet.authCDSDescription}>
                        {Messages.lookUpPrintMagazineDescription}
                    </div>
                    <CDSAccountLookup />
                </div>
            </div>,
            this.getFooterSection(),
        ]
    }
}


class CDSAuthPageStyle extends BasePanelPageStyle {
    @styleRuleInherit
    content = {
        width: null,
    }
}


@registerStyle(CDSAuthPageStyle)
export class CDSAuthPage extends AuthPanelPage {
    getFlowOptions() {
        return {
            AuthStartPanelClass: CDSAuthStartPanel,
            onEmailCodeRequested: () => Router.changeURL(LOGIN_WITH_EMAIL_CODE_URL), // TODO @auth @cleanup still needs to be merged with the regular flow. Ok for now.
        }
    }
}
